/* ---------------------------------------------------------------------------
   AVODA — email domain typo check
   ---------------------------------------------------------------------------
   Browsers only validate the SHAPE of an email address. Every bad address in
   our form data was shape-valid and still undeliverable:

       swingdengolf@gmail.col        aol.vom          gnail.com
       faversgolf@gmil.com           gmai.com         gmaiil.com
       michael.stewart@alerageoup.com                 myyahoo.com

   ".col" and ".vom" look like perfectly good TLDs to a browser. So this
   compares the domain against a list of known-good ones by edit distance and
   OFFERS a correction.

   It never blocks. Someone on a genuinely unusual domain must always be able
   to submit — the cost of a wrong rejection is far higher than a wrong hint.

   Attaches to every input[type=email] on the page. Opt out per-field with
   data-no-email-check.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Known-good domains. Anything matching one of these exactly is left alone,
     which is what stops real addresses being "corrected" — mail.com is one
     edit from gmail.com, duck.com is two from duckduckgo, and so on. Built
     from the domains our own applicants actually use. */
  var KNOWN = [
    'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.uk', 'yahoo.com.au',
    'yahoo.co.in', 'ymail.com', 'rocketmail.com', 'hotmail.com', 'hotmail.co.uk',
    'hotmail.se', 'outlook.com', 'outlook.com.au', 'live.com', 'live.co.uk',
    'live.nl', 'live.com.au', 'msn.com', 'icloud.com', 'me.com', 'mac.com',
    'aol.com', 'mail.com', 'gmx.com', 'gmx.at', 'gmx.de', 'web.de',
    't-online.de', 'protonmail.com', 'proton.me', 'duck.com', 'hushmail.com',
    'comcast.net', 'mchsi.com', 'talktalk.net', 'btinternet.com', 'sky.com',
    'virginmedia.com', 'bigpond.com', 'aussiebb.com.au', 'orange.fr',
    'kpnmail.nl', 'poczta.fm', 'hotmail.fr', 'hotmail.de', 'pga.com'
  ];

  /* Levenshtein, bailing out once we're past anything we'd act on. */
  function distance(a, b, cap) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > cap) return cap + 1;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      var rowMin = cur[0];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(
          prev[j] + 1,
          cur[j - 1] + 1,
          prev[j - 1] + (a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1)
        );
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > cap) return cap + 1;
      prev = cur.slice();
    }
    return prev[b.length];
  }

  function suggestion(value) {
    var email = String(value || '').trim();
    var at = email.lastIndexOf('@');
    if (at < 1) return null;

    var local = email.slice(0, at);
    var domain = email.slice(at + 1).toLowerCase();
    if (domain.length < 4 || domain.indexOf('.') < 1) return null;
    if (KNOWN.indexOf(domain) !== -1) return null;   // real address, leave it

    var best = null, bestDist = 3;
    for (var i = 0; i < KNOWN.length; i++) {
      var candidate = KNOWN[i];
      if (Math.abs(domain.length - candidate.length) > 2) continue;
      var d = distance(domain, candidate, 2);
      if (d > 0 && d < bestDist) { bestDist = d; best = candidate; }
    }
    return best ? local + '@' + best : null;
  }

  /* One stylesheet, injected once, so this works in any form. */
  var STYLE_ID = 'avoda-email-check-css';
  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent =
      '.avoda-email-hint{margin:.5rem 0 0;font-size:.88rem;line-height:1.5}' +
      '.avoda-email-hint button{background:none;border:0;padding:0;font:inherit;' +
      'font-weight:700;color:inherit;text-decoration:underline;cursor:pointer}';
    document.head.appendChild(el);
  }

  function hintFor(input) {
    var existing = input.parentElement &&
      input.parentElement.querySelector('.avoda-email-hint');
    if (existing) return existing;
    var p = document.createElement('p');
    p.className = 'ff__help avoda-email-hint';   /* inherits form styling where present */
    p.hidden = true;
    if (input.parentElement) input.parentElement.appendChild(p);
    return p;
  }

  function check(input) {
    if (!input.value) return;
    var hint = hintFor(input);
    var fixed = suggestion(input.value);

    if (!fixed) { hint.hidden = true; hint.textContent = ''; return; }

    hint.textContent = 'Did you mean ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = fixed;
    btn.addEventListener('click', function () {
      input.value = fixed;
      hint.hidden = true;
      hint.textContent = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    });
    hint.appendChild(btn);
    hint.appendChild(document.createTextNode('?'));
    hint.hidden = false;
  }

  function attach(input) {
    if (input.dataset.avodaEmailCheck === '1') return;
    if (input.hasAttribute('data-no-email-check')) return;
    input.dataset.avodaEmailCheck = '1';
    ensureStyles();
    input.addEventListener('blur', function () { check(input); });
    /* Clear the hint as soon as they start correcting it themselves. */
    input.addEventListener('input', function () {
      var hint = input.parentElement &&
        input.parentElement.querySelector('.avoda-email-hint');
      if (hint && !hint.hidden) { hint.hidden = true; hint.textContent = ''; }
    });
  }

  function scan(root) {
    var inputs = (root || document).querySelectorAll('input[type="email"]');
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  /* Sections re-render in the theme editor, and multi-step forms can reveal
     fields after load, so keep watching. */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            if (added[j].matches && added[j].matches('input[type="email"]')) attach(added[j]);
            else scan(added[j]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
